import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/wazifame.com/httpdocs/src/app/(www)/jobs/_components/ClientSideFilters.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/wazifame.com/httpdocs/src/app/(www)/jobs/_components/Filters.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JobCardLoading"] */ "/var/www/vhosts/wazifame.com/httpdocs/src/app/(www)/jobs/_components/JobCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/wazifame.com/httpdocs/src/app/(www)/jobs/_components/MobileFilters.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/wazifame.com/httpdocs/src/app/(www)/jobs/MainContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/wazifame.com/httpdocs/src/components/Pagination/Pagination.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/wazifame.com/httpdocs/src/components/ui/Jobs/jobs-search.tsx");
